import React, { useState } from "react";
import axios from "axios";
import { apiUrl } from "../../common/config/apiUrl";
import { motion } from "framer-motion";

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    contact_no: "",
    country: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // Validation function
  const validate = () => {
    let tempErrors = {};

    if (!formData.name.trim()) tempErrors.name = "Name is required.";
    if (!formData.email.trim()) tempErrors.email = "Email is required.";

    if (!formData.contact_no.trim())
      tempErrors.contact_no = "Mobile number is required.";

    if (!formData.country.trim()) tempErrors.country = "Country is required.";
    if (!formData.message.trim()) tempErrors.message = "Message is required.";

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  // Handle input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });

    // Clear errors as user types
    setErrors({ ...errors, [e.target.name]: "" });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);
    setError("");
    setSuccess("");

    try {
      const response = await axios.post(`${apiUrl}contacts/store`, formData, {
        headers: { "Content-Type": "application/json" },
      });

      if (response) {
        setSuccess("Message sent successfully!");
        setFormData({
          name: "",
          email: "",
          contact_no: "",
          country: "",
          message: "",
        });
      }
    } catch (err) {
      setError("Failed to send message. Please try again.");
    }

    setLoading(false);
  };

  return (
    <div
      className="bg-cover bg-no-repeat md:px-10 px-5 md:py-7 py-5"
      style={{ backgroundImage: "url('/contact-section.png')" }}
    >
      <div className="max-w-6xl mx-auto border border-[#FFC400] rounded-3xl small:p-8 p-4 grid md:grid-cols-2 gap-8 shadow-lg bg-white">
        {/* Left Section */}
        <div className="md:border-r md:pr-8">
          <h3 className="text-secondary font-semibold uppercase text-[18px]">
            Quick Contact
          </h3>
          <p className="h-[2px] w-[20%] bg-[#FFC400]"></p>
          <h2 className="md:text-2xl text-xl font-bold mt-2">
            Have Questions?
          </h2>
          <h2 className="md:text-2xl text-xl font-bold">
            Don't Hesitate To Contact Us
          </h2>
          <p className="text-[#9B9B9B] mt-4 small:overflow-hidden small:whitespace-nowrap  small:animate-typing">
            We’re here to help with any questions or support you need.
          </p>

          <div className="mt-6 grid small:grid-cols-2 grid-cols-1 gap-3 items-center gap-x-6">
            <div className="flex items-center space-x-3">
              <img
                src={require("../../common/images/contact.png")}
                alt="Illustration"
                className="w-[50px]"
              />
              <div>
                <p className="text-black font-semibold">Quick Contact</p>
                <p className="text-black">Phone:</p>
                <p className="text-[#9B9B9B]">( +44 ) 1293730103</p>
              </div>
            </div>
            <div className="flex items-center space-x-3 mt-0">
              <img
                src={require("../../common/images/opening-hours.png")}
                alt="Illustration"
                className="w-[50px]"
              />
              <div>
                <p className="text-black font-semibold">Opening Hours</p>
                <p className="text-black">Mon - Friday</p>
                <p className="text-[#9B9B9B]">10:00 am to 6:00 pm</p>
              </div>
            </div>
            <div>
              <p className="text-black font-semibold mt-5">Email:</p>
              <a
                href="mailto:info@binaryops.co"
                className="text-[#9B9B9B] cursor-pointer"
              >
                info@binaryops.co
              </a>
            </div>
          </div>
          <div className="image">
            <img
              src={require("../../common/images/quick-connect.png")}
              alt="Illustration"
              className="w-[80%] mx-auto"
            />
          </div>
        </div>

        {/* Right Section - Contact Form */}
        <div>
          <h3 className="text-secondary font-semibold uppercase text-[18px]">
            Let's Connect
          </h3>
          <p className="h-[2px] w-[20%] bg-[#FFC400]"></p>
          <h2 className="text-2xl font-bold mt-2">Send Your Message</h2>
          <p className="text-[#9B9B9B] mt-4">
            Fill out the form below, and we’ll get back to you as soon as
            possible.
          </p>

          <form onSubmit={handleSubmit} className="mt-6 space-y-4">
            <div className="grid md:grid-cols-2 gap-4">
              <div>
                <label className="text-base">Name*</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Your name"
                  className="border p-3 w-full rounded-md focus:outline-none mt-2"
                />
                {errors.name && (
                  <p className="text-red-500 text-sm px-2 py-1">
                    {errors.name}
                  </p>
                )}
              </div>
              <div>
                <label className="text-base">Email Address*</label>
                <input
                  type="text"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Your email"
                  className="border p-3 w-full rounded-md focus:outline-none mt-2"
                />
                {errors.email && (
                  <p className="text-red-500 text-sm px-2 py-1">
                    {errors.email}
                  </p>
                )}
              </div>
            </div>
            <div className="grid md:grid-cols-2 gap-4">
              <div>
                <label className="text-base">Mobile Number*</label>
                <input
                  type="text"
                  name="contact_no"
                  value={formData.contact_no}
                  onChange={handleChange}
                  placeholder="Your Mobile Number"
                  className="border p-3 w-full rounded-md focus:outline-none mt-2"
                />
                {errors.contact_no && (
                  <p className="text-red-500 text-sm px-2 py-1">
                    {errors.contact_no}
                  </p>
                )}
              </div>
              <div>
                <label className="text-base">Country Name*</label>
                <input
                  type="text"
                  name="country"
                  value={formData.country}
                  onChange={handleChange}
                  placeholder="Your Country"
                  className="border p-3 w-full rounded-md focus:outline-none mt-2"
                />
                {errors.country && (
                  <p className="text-red-500 text-sm px-2 py-1">
                    {errors.country}
                  </p>
                )}
              </div>
            </div>
            <div>
              <label className="text-base">Type Your Message Here*</label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Type Your Message Here"
                className="border p-3 w-full rounded-md h-32 focus:outline-none mt-2"
              ></textarea>
              {errors.message && (
                <p className="text-red-500 text-sm px-2 py-1">
                  {errors.message}
                </p>
              )}
            </div>

            <motion.button
              type="submit"
              className="bg-gradient-to-b from-[#055594] to-[#1068AD]  rounded-lg text-white px-6 py-3 font-semibold w-full transition-all duration-300"
              disabled={loading}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              {loading ? "Submitting..." : "SUBMIT NOW"}
            </motion.button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactSection;
